import React, { useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import { personalInfo } from '../../data/skills';
import BigBangSimulation from './BigBangSimulation';



const Hero = () => {
  const heroRef = useRef(null);

  useEffect(() => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    canvas.style.position = 'fixed';
    canvas.style.top = '0';
    canvas.style.left = '0';
    canvas.style.zIndex = '-1';
    canvas.style.pointerEvents = 'none';
    document.body.appendChild(canvas);

    const particles = [];
    for (let i = 0; i < 100; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 0.5,
        vy: (Math.random() - 0.5) * 0.5,
        size: Math.random() * 2 + 1
      });
    }

    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = 'rgba(79, 70, 229, 0.1)';
      
      particles.forEach(particle => {
        particle.x += particle.vx;
        particle.y += particle.vy;
        
        if (particle.x < 0 || particle.x > canvas.width) particle.vx *= -1;
        if (particle.y < 0 || particle.y > canvas.height) particle.vy *= -1;
        
        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.size, 0, Math.PI * 2);
        ctx.fill();
      });
      
      requestAnimationFrame(animate);
    };
    animate();

    return () => document.body.removeChild(canvas);
  }, []);

  return (
    <section className="hero-section" ref={heroRef}>
      <h1 style={{ 
        position: 'absolute', 
        top: '20px', 
        left: '20px', 
        fontSize: '16px', 
        color: 'rgba(255,255,255,0.8)', 
        zIndex: 1000,
        margin: 0,
        fontWeight: 'normal'
      }}>
        Abrar Shaikh - Full Stack Developer
      </h1>
      <div className="bigbang-section">
        <BigBangSimulation />
        <div className="scroll-indicator">
          <span>Scroll to explore</span>
          <div className="scroll-arrow">↓</div>
        </div>
      </div>
    </section>
  );
};

export default Hero;